import Axios from "axios";
import ApiUtils from "../utils/api_utils";
const BaseUrl = `https://${ApiUtils.authority}`;

const CalendarSM = {
  state: {
    listAll: [],
    listEventsMonthly: [],
    listEventsWeekly: [],
    listAppointmentsMonthly: [],
    listAppointmentsWeekly: [],
    listGreetingsMonthly: [],
    listGreetingsWeekly: [],
    listMembers: [],
  },
  reducers: {
    setCalendarState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getListAll(payload, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/events/api/events/?pagination=false`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listAll: response.data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListEventsMonthly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/events/monthly/?date=${payload}&type=monthly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listEventsMonthly: response.data,
          });
          result = {
            status: 200,
            message: "success",
            data: response.data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListEventsWeekly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/events/weekly/?date=${payload}&type=weekly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listEventsWeekly: response.data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListAppointmentsMonthly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/remainders/monthly/?date=${payload}&type=monthly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listAppointmentsMonthly: response.data,
          });
          result = {
            status: 200,
            message: "success",
            data: response.data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListAppointmentsWeekly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/remainders/weekly/?date=${payload}&type=weekly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listAppointmentsWeekly: response.data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListGreetingsMonthly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/greetings/monthly/?date=${payload}&type=monthly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listGreetingsMonthly: response.data,
          });
          result = {
            status: 200,
            message: "success",
            data: response.data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListGreetingsWeekly(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/events/api/greetings/weekly/?date=${payload}&type=weekly`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listGreetingsWeekly: response.data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListMembers(payload, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/profiles/api/users/?page=1&search=`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listMembers: response.data.results,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListMembersWithParams(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/profiles/api/users/?page=1&search=${payload}`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.CalendarSM.setCalendarState({
            ...rootState.CalendarSM,
            listMembers: response.data.results,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async postReminder(payload, rootState) {
      console.log("payload: ", payload);
      let result;
      await Axios.post(`${BaseUrl}/events/api/remainders/`, payload, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          result = {
            data: response,
            status: 200,
            message: "Success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default CalendarSM;
